// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3q2vw","fileBtn":"File_fileBtn__2txXp","closeBtn":"File_closeBtn__3PM-Y","fileSelected":"File_fileSelected__3QSUr","disabled":"File_disabled__3q8Y9"};